import { isValidPhone } from '@/modules/common/helpers/phone';
import { object, string } from 'yup';
import { isFullName } from '@/modules/common/helpers/name';
import { getString } from '@/modules/common/helpers/resources';
import { YupValidation } from '@/modules/common/helpers/yup-validation';

export class PensionValidator {
  /**
   * Creates a new validator for lead/user data.
   * Usage: PensionValidator.lead().validate({ name, email ...})
   */
  public static lead() {
    const leadSchema = object().shape({
      name: string()
        .test({
          test: isFullName,
          message: getString('common_field_fullname_error_invalid')
        })
        .required(getString('common_field_fullname_error_required')),

      phone: string()
        .transform((currentValue: string, originalValue: string) => {
          return originalValue.substring(3);
        })
        .test({
          test: isValidPhone,
          message: getString('common_field_mobile_error_invalid')
        })
        .required(getString('common_field_mobile_error_required')),

      email: string()
        .email(getString('common_field_email_error_invalid'))
        .required(getString('partner_signup_email_error_required'))
    });
    return new YupValidation(leadSchema);
  }
}
